import { render } from "./UserRolesDialog.vue?vue&type=template&id=574c60ac"
import script from "./UserRolesDialog.vue?vue&type=script&lang=js"
export * from "./UserRolesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__